module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', _vm._g({
    staticClass: "vc-svg-icon",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox
    }
  }, _vm.$listeners), [_c('path', {
    attrs: {
      "d": _vm.path
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1817ed1d!./~/vue-loader/lib/selector.js?type=template&index=0!./~/v-calendar/src/components/SvgIcon.vue
// module id = 1392
// module chunks = 94